module.exports = __webpack_public_path__ + "media/images/flags/cr-96cca3298724eeac307f21cb4ddae43d.svg";